import {BreadcrumbName} from 'common/src/modules/breadcrumbs/breadcrumbs.enums';
import {Routes} from 'common/src/modules/routing/routing.config';
import routingService from 'common/src/modules/routing/routing.service';
import {
  PollResult,
  ToolExecuteParams,
  ToolResult,
} from 'common/src/modules/shared/copilot/copilot.types';
import tool from 'common/src/modules/shared/copilot/utils/creators/tool';
import toolResult from 'common/src/modules/shared/copilot/utils/creators/toolResult';
import {poll} from 'common/src/modules/shared/copilot/utils/poll';
import {store} from 'common/src/redux/store';
import {z} from 'zod';
import {CreativesManagerAgentToolName} from '../creativesManagerAgent.enums';

const inputSchema = z.object({
  creativeId: z.number().describe('The ID of the creative to navigate to'),
});

/**
 * Check if the creative page is mounted by verifying its breadcrumb presence
 */
function _isCreativePageMounted(): PollResult {
  const state = store.getState();
  const isMounted = state.application.breadcrumbs.includes(BreadcrumbName.CreativePage);

  if (isMounted) {
    return {passed: true};
  }

  return {passed: false, reason: 'Creative page is not yet mounted'};
}

function navigateToCreativePageTool() {
  async function execute({
    input: {creativeId},
    toolUtils: {logger},
  }: ToolExecuteParams<typeof inputSchema>): Promise<ToolResult> {
    routingService.goTo({
      url: Routes.CreativeDynamicParameters,
      pathParams: {creativeId},
    });

    await poll({
      checkFn: _isCreativePageMounted,
      maxAttempts: 30,
      interval: 100,
      logger,
    });

    return toolResult(`Navigated to creative page for creative ID ${creativeId}`);
  }

  return tool({
    name: CreativesManagerAgentToolName.NavigateToCreativePage,
    description: 'Navigate to a specific creative page for editing and management',
    displayName: 'Navigating to Creative',
    execute,
    inputSchema,
  });
}

export default navigateToCreativePageTool;
